// extracted by mini-css-extract-plugin
export default {"envelope":"IRPITable_envelope__MKuX5"};